import { render } from "./Venue.vue?vue&type=template&id=2044eb77"
import script from "./Venue.js?vue&type=script&lang=js"
export * from "./Venue.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__